<template>
  <div class="OrderList">
    <GlobalInfoBar title="串号查询明细" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <OrderFrom />
      </div>
      <div class="caseOrder">
        <OrderTable ref="tableBody" />
      </div>
    </GlobalChunk>
  </div>
</template>

<script>
import _api from "@/utils/request";
import OrderFrom from "./Form";
import OrderTable from "./Table";
export default {
  name: "OrderList",
  components: { OrderFrom, OrderTable },
  data() {
    return {
      classList: null,
      merchantId: "",
      UnPayUserOrders: 0,
    };
  },
  created() {},
  methods: {
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.OrderList {
  .caseOrder {
    margin: 0 5px;
    // background: #f5f6fa;
    border-radius: 10px;
  }
}
</style>
